export default "__VITE_ASSET__i24rlQxQ__"